export const CREATE_PAGE_VIEWER = 'CREATE_PAGE_VIEWER';
export const GET_ANNOTATIONS = 'GET_ANNOTATIONS';
export const NORMALIZE_ALL = 'NORMALIZE_ALL';
export const SAVE_ANNOTATIONS = 'SAVE_ANNOTATIONS';
export const SET_IFRAME_ATTRIBUTES = 'SET_IFRAME_ATTRIBUTES';
export const GET_PAGE_BREAKS = 'GET_PAGE_BREAKS';
export const GET_TOC = 'GET_TOC';
